import api from './axios';

export interface DashboardMetrics {
    totalStudents: number;
    activeStudents: number;
    totalIncome: number;
    totalExpenses: number;
    profit: number;
    pendingDues: number;
}

export interface EnrollmentData {
    year: number;
    month: number;
    count: number;
    date: string;
}

export interface TopCourse {
    courseId: string;
    courseName: string;
    totalIncome: number;
    studentCount: number;
}

export const getDashboardMetrics = async (fiscalYear: number): Promise<DashboardMetrics> => {
    const response = await api.get('/dashboard/metrics', { params: { fiscalYear } });
    return response.data;
};

export const getEnrollmentsData = async (): Promise<EnrollmentData[]> => {
    const response = await api.get('/dashboard/enrollments');
    return response.data;
};

export const getTopCourses = async (fiscalYear: number): Promise<TopCourse[]> => {
    const response = await api.get('/dashboard/top-courses', { params: { fiscalYear } });
    return response.data;
};
